import axios from "axios";
import {
    IP
} from "../index";


// 查询视频配置
export async function selectVideoConfig() {
    var resp = await axios.post(`${IP}/admin/videoConfig/select`, {

    });
    return resp.data;
}
// 新增视频配置
export async function addVideoConfig(data) {
    var resp = await axios.post(`${IP}/admin/videoConfig/add`, data);
    return resp.data;
}
// 修改视频配置
export async function updateVideoConfig(data) {
    var resp = await axios.post(`${IP}/admin/videoConfig/update`, data);
    return resp.data;
}
// 删除视频配置
export async function deleteVideoConfig(id) {
    var resp = await axios.post(`${IP}/admin/videoConfig/delete`, {
        id
    });
    return resp.data;
}

/* 评论 */
// 查询
export async function selectCommentList(data) {
    var resp = await axios.post(`${IP}/admin/videoConfig/selectCommentList`, {
        ...data
    });
    return resp.data;
}
// 删除
export async function deleteComment(data) {
    var resp = await axios.post(`${IP}/admin/videoConfig/deleteComment`, {
        ...data
    });
    return resp.data;
}


/* 点赞 */
// 查询
export async function selectLoveList(data) {
    var resp = await axios.post(`${IP}/admin/videoConfig/selectLoveList`, {
        ...data
    });
    return resp.data;
}
// 删除
export async function deleteLove(data) {
    var resp = await axios.post(`${IP}/admin/videoConfig/deleteLove`, {
        ...data
    });
    return resp.data;
}